import { Box } from '@chakra-ui/react';
import styled from 'styled-components';

export const ChatBox = styled(Box)`
  transition: color 0.3s ease;
`;
